import { DataBean } from "../DataBean";

export class RecordProcess extends DataBean {
    


    public async getRecordProcessCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessFlow", "java.util.List_getRecordProcessCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
    public async getRecordProcess(idrecordprocess:number): Promise<any> {
        return this.getCustomService("ProcessFlow", "com.advantage.processflow.bean.RecordProcess_getRecordProcess_Number", [idrecordprocess]);
    }
  
    public async updateRecordProcess(bean:any): Promise<any> {
        return this.getCustomService("ProcessFlow", "com.advantage.processflow.bean.RecordProcess_updateRecordProcess_com.advantage.processflow.bean.RecordProcess", [
            {
                DataBeanProperties:bean,
                DataBeanName:"com.advantage.processflow.bean.RecordProcess"
            }
        ]);
    }
    public async makeRecordArchive(bean:any): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.processflow.bean.RecordProcess_makeRecordArchive_com.advantage.processflow.bean.RecordProcess", [
            {
                DataBeanProperties:bean,
                DataBeanName:"com.advantage.processflow.bean.RecordProcess"
            }
        ]);
    }
   
  

}